<template>
  <div class="screen4-header">
    <div class="address">
      <headerEditDialog></headerEditDialog>
      <el-image :src="mapIcon" style="width: 20px; height: 20px"></el-image>
      <span>江苏省苏州市​​</span>
    </div>
    <div class="screen-header-title">苏州乡镇污水监测大屏</div>
    <div class="date">{{ formattedTime }}</div>
  </div>
</template>

<script setup>
import headerEditDialog from "./header-edit-dialog.vue";
import mapIcon from "@/assets/img/screen4-header-map.png";
import { ElImage } from "element-plus";
import { ref, onMounted, onUnmounted, computed } from "vue";
import moment from "moment";
// 设置moment使用中文
moment.locale("zh-cn");

// 存储当前时间的时间戳（响应式）
const currentTimestamp = ref(Date.now());

// 定时器标识
let timer = null;

// 计算属性：格式化时间为 "YYYY-MM-DD 星期X HH:mm:ss" 格式
const formattedTime = computed(() => {
  const now = moment(currentTimestamp.value);
  // 拼接指定格式：2025-05-30 星期五 17:30:20
  return `${now.format("YYYY-MM-DD")} ${now.format("dddd")} ${now.format("HH:mm:ss")}`;
});

// 每秒更新时间戳
const updateTime = () => {
  currentTimestamp.value = Date.now();
};

// 组件挂载时启动定时器
onMounted(() => {
  console.log("header onMounted");
  // 立即更新一次
  updateTime();
  // 每秒更新
  timer = setInterval(updateTime, 1000);
});

// 组件卸载时清除定时器
onUnmounted(() => {
  if (timer) {
    clearInterval(timer);
  }
});
</script>

<style scoped lang="scss">
.screen4-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  .address {
    display: flex;
    align-items: center;
    span {
      font-weight: 500;
      font-size: 16px;
      color: #48637e;
      margin-left: 4px;
    }
    flex: 1;
  }
  .screen-header-title {
    font-size: 37px;
    color: #0c4dcc;
    line-height: 48px;
    font-family: "YouSheBiaoTiHei";
    padding-top: 8px;
    box-sizing: border-box;
    padding-right: 10px;
  }
  .date {
    font-weight: 500;
    font-size: 16px;
    color: #48637e;
    line-height: 24px;
    flex: 1;
    text-align: right;
  }
}
</style>
